import React from 'react';

import type { AvailableIconName } from '@/assets/icons';
import type { FC } from 'react';
import type { SvgProps } from 'react-native-svg';

import { iconRegistry } from '@/assets/icons';

export interface ISvgIconProps extends SvgProps {
  name: AvailableIconName;
  size?: number;
  color?: string;
  customStroke?: string;
  width?: number;
  height?: number;
}

const SvgIconComponent: FC<ISvgIconProps> = ({
  name,
  size = 24,
  color,
  width,
  height,
  ...props
}) => {
  const IconComponent = iconRegistry[name];

  if (!IconComponent) {
    // Fallback for missing icons
    console.warn(`SvgIcon: Icon "${name}" not found`);
    return null;
  }

  return <IconComponent width={width || size} height={height || size} color={color} {...props} />;
};

export const SvgIcon = React.memo(SvgIconComponent);
